import {
  AGE_GROUP_VALUES,
  ASSET_LAYER_VALUES,
  ASSET_TYPE_FILTER_VALUES,
  COLOR_PALETTE_VALUES,
  CULTURAL_CONTEXT_VALUES,
  GENDER_VALUES,
  GENRE_VALUES,
  INTENSITY_LEVEL_VALUES,
  MOOD_VALUES,
  PERFORMANCE_CONTEXT_VALUES,
  SEASONALITY_VALUES,
  type AgeGroup,
  type AssetLayer,
  type AssetTypeFilter,
  type ColorPalette,
  type CulturalContext,
  type Gender,
  type Genre,
  type IntensityLevel,
  type Mood,
  type PerformanceContext,
  type Seasonality,
} from './assetContracts';

const toLabel = (value: string): string =>
  value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

const buildLabelMap = <TValue extends string>(
  values: readonly TValue[]
): Record<TValue, string> =>
  values.reduce(
    (acc, value) => {
      acc[value] = toLabel(value);
      return acc;
    },
    {} as Record<TValue, string>
  );

export const assetLayerValues = ASSET_LAYER_VALUES;
export const assetTypeFilterValues = ASSET_TYPE_FILTER_VALUES;
export const genderValues = GENDER_VALUES;
export const genreValues = GENRE_VALUES;
export const moodValues = MOOD_VALUES;
export const intensityLevelValues = INTENSITY_LEVEL_VALUES;
export const ageGroupValues = AGE_GROUP_VALUES;
export const performanceContextValues = PERFORMANCE_CONTEXT_VALUES;
export const culturalContextValues = CULTURAL_CONTEXT_VALUES;
export const colorPaletteValues = COLOR_PALETTE_VALUES;
export const seasonalityValues = SEASONALITY_VALUES;

export const assetLayerLabels: Record<AssetLayer, string> = buildLabelMap(ASSET_LAYER_VALUES);
export const assetTypeFilterLabels: Record<AssetTypeFilter, string> =
  buildLabelMap(ASSET_TYPE_FILTER_VALUES);
export const genderLabels: Record<Gender, string> = buildLabelMap(GENDER_VALUES);
export const genreLabels: Record<Genre, string> = buildLabelMap(GENRE_VALUES);
export const moodLabels: Record<Mood, string> = buildLabelMap(MOOD_VALUES);
export const intensityLevelLabels: Record<IntensityLevel, string> =
  buildLabelMap(INTENSITY_LEVEL_VALUES);
export const ageGroupLabels: Record<AgeGroup, string> = buildLabelMap(AGE_GROUP_VALUES);
export const performanceContextLabels: Record<PerformanceContext, string> =
  buildLabelMap(PERFORMANCE_CONTEXT_VALUES);
export const culturalContextLabels: Record<CulturalContext, string> =
  buildLabelMap(CULTURAL_CONTEXT_VALUES);
export const colorPaletteLabels: Record<ColorPalette, string> =
  buildLabelMap(COLOR_PALETTE_VALUES);
export const seasonalityLabels: Record<Seasonality, string> =
  buildLabelMap(SEASONALITY_VALUES);
